import React from 'react'
import {connect} from "react-redux";
import PropTypes from 'prop-types'

import { 
  selectFiltersByMulti,
  selectIsFilterActive
} from '../../State/selectors.js'

import {
  executeFilter, 
} from '../../State/actions.js'

const mapStateToProps = (state, ownProps) => {
  var filter = selectFiltersByMulti(state, {
    param : ownProps.param, 
    value : ownProps.value
  })[0]
  var filterId = filter ? filter.id : null
  var isActive = selectIsFilterActive(state, filterId)
  return { filterId, isActive }
}

const actions = {
  executeFilter,
}

class FilterToggleControl extends React.Component {
  static get propTypes () {
    return {
      context: PropTypes.string, 
      copy: PropTypes.string,
      filterId : PropTypes.string,
      executeFilter: PropTypes.func,
      isActive: PropTypes.bool
    }
  }

  render () {
    var { context, copy, filterId, isActive, executeFilter } = this.props
    var linkClasses = [
      "filter-link",
      `id-${context}`,
      isActive ? "active" : null
    ]
    return (
      <div className={`fdn-search-control uk-button uk-button-default ${isActive ? " uk-active" : ""}`}
        onClick={() => executeFilter(filterId)}>
        <div>
          <a className={linkClasses.join(" ")}
          >

          { copy }

        </a>
      </div>
    </div>
    )
  }
}

export default connect(mapStateToProps, actions)(FilterToggleControl);
